<style>
#main__wrapper {
  height: 100%;
  margin-top: -25px;
}
.legend {
  display: inline-block;
  width: 16px;
  height: 16px;
}
.legend:hover,
.legend > img:hover {
  transition: box-shadow 0.2s;
}
.legend:not(.legend-img):hover {
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.75);
}
.legend > img:hover {
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.75);
}
.legend-circle {
  border-radius: 50%;
  background-color: black;
}
.legend-poly {
  border-radius: 10%;
  background-color: black;
}
.legend-line {
  height: 2px;
  background-color: black;
  top: 50%;
}
#legendModal .legend-transition.legend-poly,
#legendModal .legend.legend-poly,
#legendModal .legend-transition.legend-circle,
#legendModal .legend.legend-circle {
  position: relative;
  top: 3px;
}
.legend-img {
  top: -2px;
  position: relative;
}
#legendModal .v--modal-box.v--modal {
  min-width: 380px !important;
  min-height: 280px !important;
}
#legendModal .modal__content {
  overflow-y: auto !important;
}
/* #legendModal .modal__footer {
  display: none;
} */
#legendModal .v-expansion-panel {
  box-shadow: none;
  border-bottom: 1px solid lightgrey;
}
#legendModal .v-expansion-panel__header {
  padding: 0;
}
.v-card > ul > li:last-child {
  border-bottom: 0px;
}
.v-card > ul > li:first-child {
  border-top: 1px solid lightgrey;
}
.zoomToExtent {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.zoomToExtent > i {
  height: 100%;
}
#map-legend {
  height: 100%;
  margin-top: 20px;
}
</style>

<template>
  <div class="wrapper">
    <Modal
      modalName="legendModal"
      :title="!isAdminSymbolization ? 'LEGENDA MAPY' : 'SYMBOLIZACJA WARSTW'"
      :buttons="['iconUploaderOpen']"
      @opened="expansionOpened()"
      @closed="close"
      @iconUploaderOpen="iconUploaderOpen"
    >
      <div id="map-legend">
        <v-layout style="marign-top:-20px;margin-bottom:20px;">
          <v-btn
            color="#2a579a"
            dark
            depressed
            @click="clearLocaleStyles"
            style="margin-left:0px"
          >WYCZYŚĆ LOKALNE STYLE</v-btn>
        </v-layout>
        <v-layout
          wrap
          align-center
          id="main__wrapper"
        >
          <!-- <v-icon @click="clearLocaleStyles" title="Wyczyść lokalne style">delete</v-icon> -->
          <!-- <v-icon
            @click="iconUploaderOpen"
            v-if="isAdminSymbolization"
            title="Dodaj nowe ikony"
          >add_circle_outline</v-icon>-->
          <!-- <v-btn
            dark
            depressed
            @click="clearLocaleStyles"
            style="top: 8px;"
          >Wyczyść lokalne style</v-btn>-->
          <!-- <v-btn
            dark
            depressed
            @click="iconUploaderOpen"
            style="top: 8px;"
            v-if="isAdminSymbolization"
          >Dodaj nowe ikony</v-btn>-->
          <v-expansion-panel
            v-model="panel"
            expand
          >
            <v-expansion-panel-content :key="0">
              <v-subheader
                class="font--primary"
                slot="header"
              >Warstwy systemowe</v-subheader>
              <v-card>
                <span style="display: flex; justify-content: space-between">
                  <h4
                    v-if="layersWater.length > 0"
                    class="font--primary"
                  >Warstwy wodociągowe</h4>
                  <span v-if="layersWater.length > 0">
                    <span
                      class="icon"
                      title="Włącz widoczność wszystkich warstw z tej grupy"
                    >
                      <v-icon
                        @click="showGroupLayer('layersWater', layersWater)"
                        small
                      >visibility</v-icon>
                    </span>
                    <span
                      class="icon"
                      title="Wyłącz widoczność wszystkich warstw z tej grupy"
                    >
                      <v-icon
                        @click="hideGroupLayer('layersWater', layersWater)"
                        small
                      >visibility_off</v-icon>
                    </span>
                  </span>
                  <span v-if="layersWater.length == 0">Nie masz dostępu do żadnej z warstw wodociągowych</span>
                </span>
                <ul
                  id="water_layers"
                  class="values__list"
                >
                  <li
                    class="list__container--el"
                    v-for="layer in layersWater"
                    :key="layer.full_type"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.full_type"
                        :value="layer.full_type"
                        @change="toggleLayer($event)"
                        v-model="visibleLayers[layer.full_type]"
                        v-if="!isAdminSymbolization"
                      >
                      <label v-text="layer.full_name"></label>
                    </span>

                    <span>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer)"
                        title="Przybliż do zasięgu warstwy"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        v-if="!!getLayerStyleClass(layer)"
                        @click="modifyStyleOpen(layer)"
                      >
                        <template v-if="getLayerStyleClass(layer) != 'legend-img'">
                          <span
                            class="legend legend-transition"
                            v-bind:class="[getLayerStyleClass(layer)]"
                            v-bind:style="getLayerStyleOptions(layer)"
                            @click="modifyStyleOpen(layer)"
                            title="Zmień stylizację warstwy"
                          ></span>
                        </template>
                        <template v-else-if="getLayerStyleClass(layer) == 'legend-img'">
                          <span class="legend legend-img legend-transition">
                            <img
                              width="16"
                              height="16"
                              v-bind:src="getLayerStyleOptions(layer)"
                              @click="modifyStyleOpen(layer)"
                              title="Zmień stylizację warstwy"
                            >
                          </span>
                        </template>
                      </label>
                    </span>
                  </li>
                </ul>
                <span style="display: flex; justify-content: space-between">
                  <h4
                    v-if="layersSewer.length > 0"
                    class="font--primary"
                  >Warstwy kanalizacyjne</h4>
                  <span v-if="layersSewer.length > 0">
                    <span
                      class="icon"
                      title="Włącz widoczność wszystkich warstw z tej grupy"
                    >
                      <v-icon
                        @click="showGroupLayer('layersSewer', layersSewer)"
                        small
                      >visibility</v-icon>
                    </span>
                    <span
                      class="icon"
                      title="Wyłącz widoczność wszystkich warstw z tej grupy"
                    >
                      <v-icon
                        @click="hideGroupLayer('layersSewer', layersSewer)"
                        small
                      >visibility_off</v-icon>
                    </span>
                  </span>
                  <span v-if="layersSewer.length == 0">Nie masz dostępu do żadnej z warstw kanalizacyjnych</span>
                </span>
                <ul
                  id="sewer_layers"
                  class="values__list"
                >
                  <li
                    class="list__container--el"
                    v-for="layer in layersSewer"
                    :key="layer.full_type"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.full_type"
                        :value="layer.full_type"
                        @change="toggleLayer($event)"
                        v-model="visibleLayers[layer.full_type]"
                        v-if="!isAdminSymbolization"
                      >
                      <label v-text="layer.name+' - '+layer.net_type"></label>
                    </span>

                    <span>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer)"
                        title="Przybliż do zasięgu warstwy"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        v-if="!!getLayerStyleClass(layer)"
                        @click="modifyStyleOpen(layer)"
                      >
                        <template v-if="getLayerStyleClass(layer) != 'legend-img'">
                          <span
                            class="legend"
                            v-bind:class="[getLayerStyleClass(layer)]"
                            v-bind:style="getLayerStyleOptions(layer)"
                            @click="modifyStyleOpen(layer)"
                            title="Zmień stylizację warstwy"
                          ></span>
                        </template>
                        <template v-else-if="getLayerStyleClass(layer) == 'legend-img'">
                          <span class="legend legend-img">
                            <img
                              width="16"
                              height="16"
                              @click="modifyStyleOpen(layer)"
                              title="Zmień stylizację warstwy"
                              v-bind:src="getLayerStyleOptions(layer) "
                            >
                          </span>
                        </template>
                      </label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="1"
              v-if="!isAdminSymbolization"
            >
              <v-subheader
                class="font--primary"
                slot="header"
              >
                Warstwy WMS
                <v-btn
                  v-if="!loadToMap.wms"
                  flat
                  icon
                  @click.capture="execLoadToMap('wms')"
                >
                  <v-icon dark>sync</v-icon>
                </v-btn>
              </v-subheader>
              <v-card>
                <ul class="values__list">
                  <li class="list__container--el">
                    <span style="display:inherit;margin-left:0;">
                      <v-icon
                        class="table__btn--green"
                        style="margin-right:10px"
                        @click="addWMS"
                      >add_circle</v-icon>
                      <h4 class="font--primary">Dodaj WMS</h4>
                    </span>
                  </li>
                  <li
                    class="list__container--el"
                    v-if="loadToMap.wms"
                  >
                    <h4 class="font--primary">Widoczność wszystkich warstw w grupie</h4>
                    <span>
                      <span
                        class="icon"
                        title="Włącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="showGroupLayer('wmsLayers', wmsLayers)"
                          small
                        >visibility</v-icon>
                      </span>
                      <span
                        class="icon"
                        title="Wyłącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="hideGroupLayer('wmsLayers', wmsLayers)"
                          small
                        >visibility_off</v-icon>
                      </span>
                    </span>
                  </li>
                  <li
                    class="list__container--el"
                    v-for="layer in wmsLayers"
                    :key="layer.full_type"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.full_type"
                        :value="`wms_layer_${layer.id}`"
                        @change="toggleLayer($event, 'wms')"
                        v-model="visibleLayers[`wms_layer_${layer.id}`]"
                      >
                      <label v-text="layer.display_name"></label>
                    </span>
                    <span>
                      <label
                        class="zoomToExtent"
                        @click="deleteLayer(layer.full_type, 'wms', user.id === layer.user)"
                        title="Usuń warstwę"
                      >
                        <v-icon :color="user.id === layer.user ? undefined : 'red'">delete</v-icon>
                      </label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="2"
              v-if="!isAdminSymbolization"
            >
              <v-subheader
                class="font--primary"
                slot="header"
              >Warstwy dodatkowe</v-subheader>
              <v-card>
                <!-- Tutaj lista warstw -->
                <ul class="values__list">
                  <li class="list__container--el">
                    <h4 class="font--primary">Widoczność wszystkich warstw w grupie</h4>
                    <span>
                      <span
                        class="icon"
                        title="Włącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="showGroupLayer('appLayers', appLayers)"
                          small
                        >visibility</v-icon>
                      </span>
                      <span
                        class="icon"
                        title="Wyłącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="hideGroupLayer('appLayers', appLayers)"
                          small
                        >visibility_off</v-icon>
                      </span>
                    </span>
                  </li>
                  <li
                    class="list__container--el"
                    v-for="layer in appLayers"
                    :key="layer.name"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.name"
                        :value="`app_layer_${layer.name}`"
                        @change="toggleLayer($event, 'additional')"
                        v-model="visibleLayers[`app_layer_${layer.name}`]"
                      >
                      <label v-text="layer.display_name"></label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content :key="3">
              <v-subheader
                class="font--primary"
                slot="header"
              >
                Warstwy użytkownika
                <v-btn
                  v-if="!loadToMap.user"
                  flat
                  icon
                  @click.capture="execLoadToMap('user')"
                >
                  <v-icon dark>sync</v-icon>
                </v-btn>
              </v-subheader>
              <v-card>
                <!-- Tutaj lista warstw -->
                <ul class="values__list">
                  <li
                    class="list__container--el"
                    v-if="loadToMap.user"
                  >
                    <h4 class="font--primary">Widoczność wszystkich warstw w grupie</h4>
                    <span>
                      <span
                        class="icon"
                        title="Włącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="showGroupLayer('userLayers', userLayers); showGroupLayer('userRasterLayers', userRasterLayers)"
                          small
                        >visibility</v-icon>
                      </span>
                      <span
                        class="icon"
                        title="Wyłącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="hideGroupLayer('userLayers', userLayers); hideGroupLayer('userRasterLayers', userRasterLayers)"
                          small
                        >visibility_off</v-icon>
                      </span>
                    </span>
                  </li>
                  <li
                    class="list__container--el"
                    v-for="layer in userLayers"
                    :key="layer.table"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.table"
                        :value="`user_layer_${layer.table}`"
                        @change="toggleLayer($event, 'user')"
                        v-model="visibleLayers[`user_layer_${layer.table}`]"
                        v-if="!isAdminSymbolization"
                      >
                      <label v-text="layer.name"></label>
                    </span>
                    <span>
                      <label
                        v-if="!!getUserLayerStyleClass(layer)"
                        @click="modifyStyleOpen(layer)"
                      >
                        <template v-if="getUserLayerStyleClass(layer) != 'legend-img'">
                          <span
                            class="legend"
                            v-bind:class="[getUserLayerStyleClass(layer)]"
                            v-bind:style="getUserLayerStyleOptions(layer)"
                          ></span>
                        </template>
                        <template v-else-if="getUserLayerStyleClass(layer) == 'legend-img'">
                          <span class="legend legend-img">
                            <img
                              width="16"
                              height="16"
                              v-bind:src="getUserLayerStyleOptions(layer)"
                            >
                          </span>
                        </template>
                      </label>
                      <label
                        v-else
                        @click="modifyStyleOpen(layer)"
                        title="dodaj stylizację"
                      >
                        <v-icon>brush</v-icon>
                      </label>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer, 'user')"
                        title="Przybliż do zasięgu warstwy"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        class="zoomToExtent"
                        @click="deleteLayer(`user_layer_${layer.table}`, 'user', user.id === layer.posted_by)"
                        title="Usuń warstwę"
                      >
                        <v-icon :color="user.id === layer.posted_by ? undefined : 'red'">delete</v-icon>
                      </label>
                    </span>
                  </li>

                  <li
                    class="list__container--el"
                    v-for="layer in userRasterLayers"
                    :key="layer.id"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.id"
                        :value="layer.full_type"
                        @change="toggleLayer($event, 'user')"
                        v-model="visibleLayers[layer.full_type]"
                      >
                      <label v-text="layer.name"></label>
                    </span>
                    <span>
                      <label
                        class="zoomToExtent"
                        @click="show('DEMLegendModal')"
                        v-if="layer.name == 'Model terenu'"
                      >
                        <v-icon>info</v-icon>
                      </label>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer, 'user')"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        v-if="layer.name != 'Model terenu'"
                        class="zoomToExtent"
                        @click="deleteLayer(layer.full_type, 'user')"
                        title="Usuń warstwę"
                      >
                        <v-icon>delete</v-icon>
                      </label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="4"
              v-if="!isAdminSymbolization"
            >
              <v-subheader
                class="font--primary"
                slot="header"
              >Warstwy tymczasowe</v-subheader>
              <v-card>
                <!-- Tutaj lista warstw -->
                <ul class="values__list">
                  <li
                    class="list__container--el"
                    v-for="layer in tempLayers"
                    :key="layer.id"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.id"
                        :value="`temp_layer_${layer.name}_${layer.id}`"
                        @change="toggleLayer($event, 'temp')"
                        v-model="visibleLayers[`temp_layer_${layer.name}_${layer.id}`]"
                      >
                      <label v-text="layer.name"></label>
                    </span>
                    <span>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer, 'temp')"
                        title="Przybliż do zasięgu warstwy"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        class="zoomToExtent"
                        @click="deleteLayer(`temp_layer_${layer.name}_${layer.id}`, 'temp')"
                        title="Usuń warstwę"
                      >
                        <v-icon>delete</v-icon>
                      </label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
            <v-expansion-panel-content
              :key="5"
              v-if="!isAdminSymbolization"
              v-show="false"
            >
              <v-subheader
                class="font--primary"
                slot="header"
              >
                Szkice
                <v-btn
                  v-if="!loadToMap.sketche"
                  flat
                  icon
                  @click.capture="execLoadToMap('sketche')"
                >
                  <v-icon dark>sync</v-icon>
                </v-btn>
              </v-subheader>
              <v-card>
                <!-- Tutaj lista warstw -->
                <ul class="values__list">
                  <li
                    class="list__container--el"
                    v-if="loadToMap.sketche"
                  >
                    <h4 class="font--primary">Widoczność wszystkich warstw w grupie</h4>
                    <span>
                      <span
                        class="icon"
                        title="Włącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="showGroupLayer('sketchesLayers', sketchesLayers)"
                          small
                        >visibility</v-icon>
                      </span>
                      <span
                        class="icon"
                        title="Wyłącz widoczność wszystkich warstw z tej grupy"
                      >
                        <v-icon
                          @click="hideGroupLayer('sketchesLayers', sketchesLayers)"
                          small
                        >visibility_off</v-icon>
                      </span>
                    </span>
                  </li>
                  <li
                    class="list__container--el"
                    v-for="layer in sketchesLayers"
                    :key="layer.id"
                  >
                    <span>
                      <input
                        type="checkbox"
                        :id="layer.id"
                        :value="`sketche_layer_${layer.id}`"
                        @change="toggleLayer($event, 'sketche')"
                        v-model="visibleLayers[`sketche_layer_${layer.id}`]"
                      >
                      <label v-text="layer.name"></label>
                    </span>
                    <span>
                      <label
                        class="zoomToExtent"
                        @click="zoomToExtent(layer, 'sketche')"
                        title="Przybliż do zasięgu warstwy"
                      >
                        <v-icon>fullscreen</v-icon>
                      </label>
                      <label
                        class="zoomToExtent"
                        @click="deleteLayer(`sketche_layer_${layer.id}`, 'sketche', user.id === layer.posted_by)"
                        title="Usuń warstwę"
                      >
                        <v-icon :color="user.id === layer.posted_by ? undefined : 'red'">delete</v-icon>
                      </label>
                    </span>
                  </li>
                </ul>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-layout>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../shared/Modal";
import {transformExtent} from "ol/proj.js";

export default {
  data: () => ({
    panel: [],
    isAdminSymbolization: false,
    checkedGroups: []
  }),
  components: {
    Modal
  },
  methods: {
    addWMS() {
      this.show('dataImportModal')
    },
    changeAdminSymbol() {
      this.isAdminSymbolization = true;
      this.$root.$emit("changeAdminSymbolization", true);
    },
    show(title) {
      if(this.$store.getters.getModalsList.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    close() {
      this.isAdminSymbolization = false;
      this.$root.$emit("changeAdminSymbolization", false);
    },
    toggleLayer(e, type) {
      this.$root.$emit("toggleLayer", e.target.value, undefined, type);
      if(!type || type === "data") {
        setTimeout(() => this.$root.$emit("refreshAttributeTableData"), 500);
      }
    },
    showGroupLayer(name, layers) {
      let type = "data";
      switch(name) {
        case "sketchesLayers":
          type = "sketche";
          break;
        case "wmsLayers":
          type = "wms";
          break;
        case "appLayers":
          type = "additional";
          break;
        case "userLayers":
        case "userRasterLayers":
          type = "user";
          break;
      }

      for(let lay of layers) {
        let layername = lay.full_type;
        switch(name) {
          case "appLayers":
            layername = `app_layer_${lay.name}`;
            break;
          case "sketchesLayers":
            layername = `sketche_layer_${lay.id}`;
            break;
          case "userLayers":
            layername = `user_layer_${lay.table}`;
            break;
        }

        if(!this.visibleLayers[layername]) {
          this.$root.$emit("toggleLayer", layername, true, type);
        }
      }
    },
    hideGroupLayer(name, layers) {
      let type = "data";
      switch(name) {
        case "sketchesLayers":
          type = "sketche";
          break;
        case "wmsLayers":
          type = "wms";
          break;
        case "appLayers":
          type = "additional";
          break;
        case "userLayers":
        case "userRasterLayers":
          type = "user";
          break;
      }

      for(let lay of layers) {
        let layername = lay.full_type;
        switch(name) {
          case "appLayers":
            layername = `app_layer_${lay.name}`;
            break;
          case "sketchesLayers":
            layername = `sketche_layer_${lay.id}`;
            break;
          case "userLayers":
            layername = `user_layer_${lay.table}`;
            break;
        }

        if(this.visibleLayers[layername]) {
          this.$root.$emit("toggleLayer", layername, false, type);
        }
      }
    },
    modifyStyleOpen(layer) {
      this.show("modifyLayerStyle");
      if(this.isAdminSymbolization) this.$root.$emit("modifyLayerButton");
      this.$root.$emit("modifyLayer", layer);
    },
    expansionOpened() {
      if(localStorage.legendModal_expansion !== undefined) {
        this.panel = JSON.parse(localStorage.legendModal_expansion);
      }
    },
    execLoadToMap(type) {
      this.$root.$emit("loadToMap", type);
    },

    iconUploaderOpen() {
      this.show("iconStyleUploader");
    },

    //<editor-fold defaultstate="collapsed" desc="styles">
    styleToClass(layer, style) {
      let geometry_type = layer.geometry_type;
      if(layer.type === "watermeters") {
        //aby można było stylować pojedyńcze pkt wodomierzy
        geometry_type = "point";
      }

      if(geometry_type === "point") {
        if("externalGraphic" in style) {
          return "legend-img";
        } else {
          return "legend-circle";
        }
      } else if(geometry_type === "linestring") {
        return "legend-line";
      } else if(geometry_type === "polygon") {
        return "legend-poly";
      } else {
        return false;
      }
    },
    styleToOptions(layer, style) {
      let geometry_type = layer.geometry_type;
      if(layer.type === "watermeters") {
        //aby można było stylować pojedyńcze pkt wodomierzy
        geometry_type = "point";
      }

      if(geometry_type === "point") {
        if("externalGraphic" in style) {
          return `${this.$store.getters.getApiURL}/static/map_icons/${
            style.externalGraphic
            }`;
        } else {
          return {
            backgroundColor: style["circle-color"] || style["fill-color"]
          };
        }
      } else if(geometry_type === "linestring") {
        return {
          backgroundColor: style["line-color"] || style["fill-color"],
          height: `${style["line-width"] || 1}px`
        };
      } else if(geometry_type === "polygon") {
        return {
          borderWidth: "thin",
          borderStyle: "solid",
          borderColor: style["fill-outline-color"],
          backgroundColor: style["fill-color"]
        };
      } else {
        return {};
      }
    },

    getLayerStyleClass(layer) {
      if(
        !this.styles ||
        !("layers" in this.styles) ||
        !(layer.type in this.styles.layers)
      ) {
        return false;
      }

      let style = this.styles.layers[layer.type];
      return this.styleToClass(
        layer,
        layer.net_type in style ? style[layer.net_type] : style
      );
    },
    getLayerStyleOptions(layer) {
      if(
        !this.styles ||
        !("layers" in this.styles) ||
        !(layer.type in this.styles.layers)
      ) {
        return {};
      }

      let style = this.styles.layers[layer.type];
      return this.styleToOptions(
        layer,
        layer.net_type in style ? style[layer.net_type] : style
      );
    },

    getUserLayerStyleClass(layer) {
      if(
        !this.styles ||
        !("user_layers" in this.styles) ||
        !(layer.table in this.styles.user_layers)
      ) {
        return false;
      }

      return this.styleToClass(layer, this.styles.user_layers[layer.table]);
    },
    getUserLayerStyleOptions(layer) {
      if(
        !this.styles ||
        !("user_layers" in this.styles) ||
        !(layer.table in this.styles.user_layers)
      ) {
        return {};
      }

      return this.styleToOptions(layer, this.styles.user_layers[layer.table]);
    },
    //</editor-fold>

    zoomToExtent(layer, type = "wodkan") {
      if("extent" in layer) {
        if(layer.extent && layer.extent.length === 4) {
          if (type == 'user') {
            this.map.getView().fit(transformExtent(layer.extent, 'EPSG:2176', 'EPSG:2180'));
            return;
          }
          this.map.getView().fit(layer.extent);
          return;
        }
      }

      let key = "";
      switch(type) {
        case "wodkan":
          key = layer.full_type;
          break;
        case "user":
          key = `user_layer_${layer.table}`;
          break;
        case "temp":
          key = `temp_layer_${layer.name}`;
          break;
        case "sketche":
          key = `sketche_layer_${layer.name}`;
          break;
      }
      const layerInstance = this.layersInstance[key];
      let extent = [];
      if(layerInstance) {
        const source = layerInstance.getSource();
        if(!layerInstance.getVisible()) {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            `Najpierw włącz widoczność warstwy`
          );
          return;
        }
        if(source.isEmpty()) {
          this.$root.$emit(
            "showSnackbar",
            "orange",
            `Brak elementów na warstwie`
          );
          return;
        }
        extent = layerInstance.getSource().getExtent();
        if(extent && extent.length === 4) {
          this.map.getView().fit(extent);
        }
      }
    },
    deleteLayer(key, type = "wodkan", allows = true) {
      const self = this;

      if(!allows) {
        self.$root.$emit(
          "showSnackbar",
          "red",
          `Nie masz uprawnień do usunięcia tej warstwy`
        );
        return;
      }

      self.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Usuwanie warstwy",
        text: "Czy na pewno chcesz usunąć tą warstwę?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              self.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$root.$once("deletedLayer", (type2, key, value) => {
                if(type === type2) {
                  if(value) {
                    self.$forceUpdate();
                  }

                  self.$emit("confDialogOpened", false);
                  self.$modal.hide("dialog");
                }
              });
              self.$root.$emit("deleteLayer", type, self.$store.getters.getLayersInstance[key]);
            }
          }
        ]
      });
    },

    clearLocaleStyles() {
      delete localStorage.layers_styles;
      this.$store.dispatch("getStyles").then(r => {
        if(!r) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Błąd pobierania styli warstw"
          );
        } else {
          this.$root.$emit("showSnackbar", "green", "Zaktualizowano style");
        }
      });
    }
  },
  watch: {
    panel: function () {
      if(this.panel.length !== 0) {
        localStorage.legendModal_expansion = JSON.stringify(this.panel);
      }
    }
  },
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    layersWater() {
      return this.$store.getters.getLayersWater/*.filter(layer => this.$can('read', layer.type) || this.$can('edit', layer.type))*/;
    },
    layersSewer() {
      return this.$store.getters.getLayersSewer/*.filter(layer => this.$can('read', layer.type) || this.$can('edit', layer.type))*/;
    },
    appLayers() {
      return this.$store.getters.getAppLayers;
    },
    userLayers() {
      return this.$store.getters.getUserLayers;
    },
    userRasterLayers() {
      return this.$store.getters.getUserRasterLayers;
    },
    wmsLayers() {
      return this.$store.getters.getWMSLayers;
    },
    tempLayers() {
      return this.$store.getters.getTempLayers;
    },
    sketchesLayers() {
      return this.$store.getters.getSketches;
    },
    styles() {
      return this.$store.getters.getStyles;
    },
    visibleLayers: {
      get() {
        return this.$store.getters.getVisibleLayers;
      },
      set(value) {}
    },

    map() {
      return this.$store.getters.getMap;
    },
    layersInstance() {
      return this.$store.getters.getLayersInstance;
    },
    user() {
      return this.$store.getters.getUser;
    },

    loadToMap() {
      return this.$store.getters.getLoadToMap;
    }
  },
  created() {
    //console.log(this);
  },
  mounted() {
    this.$root.$on("changeAdminSymbolizationModal", this.changeAdminSymbol);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/modals/MapLegend.vue